import {GetSeferData} from "SeferPetach/GetData";


export async function getSystemLists() {
    return (await GetSeferData("gldepartment", {StatusIds: [1,2,3]}));
}

//#region Cycle
export async function getCycleList(obj) {
    const args = obj;
    var payload = await GetSeferData("gcylist", args);
    return (payload);
}
export async function getCycleByID(obj){
    const args = {
        CycleId: obj.CycleId,
    };
    var payload = await GetSeferData("gcy", args);
    return (payload);
}
export async function updateCycle(obj) {
    const args = obj;
    var payload = await GetSeferData("ucy", args);
    return (payload);
}
export async function updateCycleStatus(obj) {
    const args = obj;
    var payload = await GetSeferData("ucyst", args);
    return (payload);
}
export async function deleteCycle(obj){
    const args = obj;
    var payload = await GetSeferData("dcy", args);
    return (payload);
}
export async function updateCyclePeriod(obj) {
    const args = obj;
    var payload = await GetSeferData("ucyp", args);
    return (payload);
}
export async function deleteCyclePeriod(obj){
    const args = obj;
    var payload = await GetSeferData("dcyp", args);
    return (payload);
}
//#endregion

//#region Period Label
export async function getPeriodLabelList(obj) {
    const args = obj;
    var payload = await GetSeferData("gpllist", args);
    return (payload);
}
export async function getPeriodLabelByID(obj){
    const args = {
        PeriodLabelId: obj.PeriodLabelId,
    };
    var payload = await GetSeferData("gpl", args);
    return (payload);
}
export async function updatePeriodLabel(obj) {
    const args = obj;
    var payload = await GetSeferData("upl", args);
    return (payload);
}
export async function updatePeriodLabelStatus(obj) {
    const args = obj;
    var payload = await GetSeferData("uplst", args);
    return (payload);
}
export async function deletePeriodLabel(obj){
    const args = obj;
    var payload = await GetSeferData("dpl", args);
    return (payload);
}
//#endregion

//#region Development Stage
export async function getDevelopmentStageList() {
    var args = {};
    var payload = await GetSeferData("gdslist", args);
    return (payload);
}
export async function getDevelopmentStageByID(obj){
    const args = {
        DevelopmentStageId: obj.DevelopmentStageId,
    };
    var payload = await GetSeferData("gds", args);
    return (payload);
}
export async function updateDevelopmentStage(obj) {
    const args = obj;
    var payload = await GetSeferData("uds", args);
    return (payload);
}
export async function deleteDevelopmentStage(obj){
    const args = obj;
    var payload = await GetSeferData("dds", args);
    return (payload);
}
//#endregion


//#region Application Content
export async function getApplicationContentList() {
    var args = {};
    var payload = await GetSeferData("gaclist", args);
    return (payload);
}
export async function getApplicationContentByID(obj){
    const args = {
        AppContentId: obj.AppContentId,
    };
    var payload = await GetSeferData("gac", args);
    return (payload);
}
export async function updateApplicationContent(obj) {
    const args = obj;
    var payload = await GetSeferData("uac", args);
    return (payload);
}
export async function deleteApplicationContent(obj){
    const args = obj;
    var payload = await GetSeferData("dac", args);
    return (payload);
}
//#endregion

export async function getUserByID(user_data){
    const args = {
        UserId: user_data.UserId,
    };
    var payload = await GetSeferData("gusr", args);
    return (payload);
}

export async function updateUser(obj) {
    const args = {
        UserId                  :   obj.UserId,
        Email                   :   obj.Email,
        FirstName               :   obj.FirstName,
        LastName                :   obj.LastName,
        ModuleName              :   obj.ModuleName,
        DepartmentId            :   obj.DepartmentId,
        StatusId                :   obj.StatusId,
        HiredDate               :   obj.HiredDate,
    };
    var payload = await GetSeferData("uusr", args);
    return (payload);
}

export async function deleteUser(obj){
    const args = {
        UserId: obj.UserId
    };
    var payload = await GetSeferData("dusr", args);
    return (payload);
}

export async function getDepartmentByID(data){
    const args = {
        DepartmentId: data.DepartmentId,
    };
    var payload = await GetSeferData("gdepartment", args);
    return (payload);
}

export async function updateDepartment(obj) {
    const args = {
        DepartmentId            :   obj.DepartmentId,
        DepartmentName          :   obj.DepartmentName,
        StatusId                :   obj.StatusId,
    };
    var payload = await GetSeferData("udepartment", args);
    return (payload);
}

export async function deleteDepartment(obj){
    const args = {
        DepartmentId: obj.DepartmentId
    };
    var payload = await GetSeferData("ddepartment", args);
    return (payload);
}